(function () {
    'use strict';
    angular
        .module('app')
        .directive('questionBox', questionBox);
    questionBox.$inject = ['$window', '$rootScope', '$scope', '$timeout', 'ngClipboard', '$mdDialog'];
    function questionBox($window, $rootScope, scope, $timeout, ngClipboard, $mdDialog) {
        var directive = {
            link: link,
            restrict: 'EA',
            //scope: {
            //    msgBoxShown: '=?'
            //},
            //controller: 'confirmBox',
            templateUrl: 'app/msgBox/questionBox.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();